/* eslint-disable import/prefer-default-export */
import { localize } from '@saviynt/common';

import { getMessageKey } from '../../../utils/utils';
import { ACTION_BUTTON_KINDS } from '../constant';

export const getCommentSubmitLabel = (
  actionKind,
  messages,
  intl,
  isEOCampaign
) => {
  const APPROVE_TEXT =
    messages['Approve.Default.label.ATTESTATIONS'] ||
    localize(intl, getMessageKey('Approve.Default.label.ATTESTATIONS'));

  const CONFIRM_MANAGER_TEXT =
    messages['Confirmmanager.label.ATTESTATIONS'] ||
    localize(intl, getMessageKey('Confirmmanager.label.ATTESTATIONS'));

  switch (actionKind) {
    case ACTION_BUTTON_KINDS.APPROVE:
    case ACTION_BUTTON_KINDS.BELONGS_TO_ME:
      return APPROVE_TEXT;
    case ACTION_BUTTON_KINDS.REJECT:
      return (
        messages['Reject.Default.label.ATTESTATIONS'] ||
        localize(intl, getMessageKey('Reject.Default.label.ATTESTATIONS'))
      );
    case ACTION_BUTTON_KINDS.DECOMMISSION:
      return (
        messages.CERTS_BULK_DECOMMISSION ||
        localize(intl, getMessageKey('CERTS_BULK_DECOMMISSION'))
      );
    case ACTION_BUTTON_KINDS.TERMINATE:
      return (
        messages['Terminate.items.label.ATTESTATIONS'] ||
        localize(intl, getMessageKey('Terminate.items.label.ATTESTATIONS'))
      );
    case ACTION_BUTTON_KINDS.REASSIGN:
      return (
        messages['REASSIGNSTEP2.ATTESTATIONS.label'] ||
        localize(intl, getMessageKey('REASSIGNSTEP2.ATTESTATIONS.label'))
      );
    case ACTION_BUTTON_KINDS.CONSULT:
      return 'Consult';
    case ACTION_BUTTON_KINDS.WORKS_FOR_ME:
      return isEOCampaign ? APPROVE_TEXT : CONFIRM_MANAGER_TEXT;
    case ACTION_BUTTON_KINDS.DOES_NOT_WORK_FOR_ME:
      return (
        messages.CERTS_SUBMIT || localize(intl, getMessageKey('CERTS_SUBMIT'))
      );
    // showing submit label for user lineitem
    case ACTION_BUTTON_KINDS.EXTEND_END_DATE:
      return (
        messages.CERTS_EXTEND_END_DATE ||
        localize(intl, getMessageKey('CERTS_EXTEND_END_DATE'))
      );
    case ACTION_BUTTON_KINDS.CONDITIONAL_CERTIFIY:
      return (
        messages.CERTS_CONDITIONALLY_CERTIFY ||
        localize(intl, getMessageKey('CERTS_CONDITIONALLY_CERTIFY'))
      );
    default:
      return 'Unformatted Action';
  }
};

export default getCommentSubmitLabel;
